import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LandingPage } from './pages/LandingPage';
import { PlatformPage } from './pages/Platform';
import { SolutionsPage } from './pages/Solutions';
import { WhyROIPage } from './pages/WhyROI';
import { ResourcesPage } from './pages/Resources';
import { ContactPage } from './pages/Contact';
import { ScrollToTop } from './components/ScrollToTop';
export function App() {
  return <BrowserRouter data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <Routes data-id="element-2">
        <Route path="/" element={<LandingPage data-id="element-4" />} data-id="element-3" />
        <Route path="/platform" element={<PlatformPage data-id="element-6" />} data-id="element-5" />
        <Route path="/solutions" element={<SolutionsPage data-id="element-8" />} data-id="element-7" />
        <Route path="/why-roi" element={<WhyROIPage data-id="element-10" />} data-id="element-9" />
        <Route path="/resources" element={<ResourcesPage data-id="element-12" />} data-id="element-11" />
        <Route path="/contact" element={<ContactPage data-id="element-14" />} data-id="element-13" />
      </Routes>
    </BrowserRouter>;
}